export default __webpack_public_path__ + "static/media/thumb_bs4.b87411ce.png";